<template>
  <div
    :class="rootClass"
    :style="rootStyle"
    v-html="svg"
    v-on="$listeners"
  />
</template>

<script>
export default {
  props: {
    svg: {
      type: String,
    },
    size: {
      type: Number,
      default: 40,
    },
    button: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rootStyle () {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
      }
    },
    rootClass () {
      return [this.$style.root, {
        [this.$style.root_button]: this.button,
      }]
    },
  },
}
</script>

<style lang="scss" module>
.root {
  @apply fill-current;

  > svg {
    @apply block;
  }
}

.root_button {
  @apply cursor-pointer;
}
</style>
